<template>
    <div class="learnList">
        <div class="learnMore">
            <span @click="enterLearnMore">更多</span>
            <i class="el-icon-plus" @click="enterLearnMore"></i>
        </div>
        <div class="learn-item-list">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        //路由分类 默认是 'university' -- 老年大学, 'classRoom' -- 市民课堂
        routeSort:{
            type:String,
            default:''
        },
        //学习课程分类
        learnSort:{
            type:String,
            default:''
        },
        //学习课程list
        learnCourseList:{
            type:Array,
            default(){
                return[]
            }
        }
    },
    data(){
        return {

        }
    },
    methods:{
        //进入更多学习列表
        enterLearnMore(){
            let path = this.routeSort == 'university' ? '/pcViews/learn/university-list' : '/pcViews/learn/class-room-list';
            this.$router.push({
                path,
                query:{
                    learnSort:this.learnSort
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.learnList{
    margin-left: 3px;
    flex: 1;
    .learnMore{
        height: 20px;
        text-align: right;
        font-size: 12px;
        color: #242424;
        cursor: pointer;
    }
    .learn-item-list{
        flex: 1;
        display: flex;
        flex-wrap: wrap;
    }
}
</style>
